module.exports = __webpack_public_path__ + "img/ic_publicity_detail6_1.2b6cc7e9.jpg";